export const SET_REPORT_LIST = "SET_REPORT_LIST";

export const GET_REPORT_LIST = "GET_REPORT_LIST";
export const GET_REPORT_LIST_LOADING = "GET_REPORT_LIST_LOADING";

export const SUBMIT_REPORT = "SUBMIT_REPORT";
